import { pick } from 'lodash-es'

import { findValuesByKeys, isNotEmptyArray } from '@/utils'

import CONFIG_MAP from './config'

// 获取值，如果key为item，则返回item，否则返回item[key]
const getValue = (item: any, key: string) => {
  if (!key) return ''
  return key === 'item' ? item : item[key]
}

// 处理数据列表
export const dealDataList = (arr: any[], fieldNames: any) => {
  if (!isNotEmptyArray(arr)) return []
  const { label, value, code, label_name, label_text, value_name } = fieldNames || {}
  const labeName = label_name || label || 'name'
  const codeName = label_text || code || ''
  const valueName = value_name || value || 'id'
  return (arr || []).map((item: any) => {
    const labelText = getValue(item, labeName)
    const codeText = getValue(item, codeName)
    const valueText = getValue(item, valueName)
    return {
      ...(labeName === 'item' ? {} : item),
      label: labelText,
      value: valueText,
      code: codeText
    }
  })
}

// 处理初始化参数
export const getInitArgument = (propInitArgument: any, confInitArgument: any) => {
  // 如果initArgument是数组，则返回initArgument
  if (Array.isArray(propInitArgument)) {
    return propInitArgument
  }
  if (Array.isArray(confInitArgument)) {
    return confInitArgument
  }
  // 如果initArgument是对象，则返回initArgument和restProps?.initArgument的合并
  return {
    ...confInitArgument,
    ...propInitArgument
  }
}

// 处理初始化参数
export const dealSearchParams = (paramsList: any[]) => {
  if (isNotEmptyArray(paramsList)) {
    // 如果有一个为数组则返回为参数，比如银行名称接口
    for (const item of paramsList) {
      if (isNotEmptyArray(item)) {
        return item
      }
    }
    // 其他后面覆盖前面，合并参数
    return {
      paged: false,
      enable_status: 1,
      ...paramsList?.reduce((acc: any, item: any) => {
        acc = {
          ...acc,
          ...item
        }
        return acc
      }, {})
    }
  }
  return {
    paged: false,
    enable_status: 1
  }
}

// 兼容PC和H5的fieldNames
const dealFieldNames = (fieldNames: any) => {
  const { label, value, code, label_name, label_text, value_name } = fieldNames || {}
  const labeName = label_name || label || 'name'
  const codeName = label_text || code || ''
  const valueName = value_name || value || 'id'
  return { label: labeName, code: codeName, value: valueName }
}

// 处理查询配置
export const dealQueryConfig = (
  props: any
): {
  url: string
  method: string
  dataPath: string
  enableCustomItems: boolean
  fieldNames: any
  searchParams: any
} => {
  const { fieldNames, fieldItem, initArgument, config, category, searchParams } = findValuesByKeys(
    props,
    ['config', 'category', 'fieldNames', 'fieldItem', 'initArgument', 'searchParams']
  )
  // 配置
  const { type: configType } = config || {}
  // 数据类型
  const categoryType = configType || category
  const params = [initArgument, searchParams]
  const queryConfig = findValuesByKeys(props, ['url', 'method', 'dataPath', 'enableCustomItems'])
  const fieldNamesMap = fieldNames || fieldItem || {}

  if (!categoryType) {
    return {
      ...queryConfig,
      fieldNames: dealFieldNames(fieldNamesMap),
      searchParams: dealSearchParams(params)
    }
  }

  const conf = CONFIG_MAP?.[categoryType] || {}

  // 合并initArgument
  return {
    ...pick(conf, ['url', 'method', 'dataPath', 'enableCustomItems']),
    fieldNames: dealFieldNames({
      ...conf?.fieldNames,
      ...fieldNamesMap
    }),
    searchParams: dealSearchParams([conf?.searchParams, ...params])
  }
}

// 处理自定义项目
export const dealCustomItems = (list: any[], value: string) => {
  // 如果是原始值，则不添加自定义项目
  const isOriginal = list?.some((x: any) => x?.value === value)
  if (isOriginal || !value) {
    return list
  }
  return [{ id: value, label: value, name: value, value: value }, ...list]
}
